// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1630":"2dbd69f0","2546":"861b7b69","4281":"09600084","7273":"09600084","8688":"f8536d39"}[chunkId] + ".chunk.css";
};